class Recents {
    constructor() {
        this.storageKey = 'search:recents';
        this.maxRecents = 10;
    }

    add(model, id) {
        const recents = this.get();

        const newRecent = { model, id, timestamp: Date.now() };

        const filtered = recents.filter(item => !(item.model === model && item.id === id));

        const updated = [newRecent, ...filtered].slice(0, this.maxRecents);

        localStorage.setItem(this.storageKey, JSON.stringify(updated));

        return updated;
    }

    get() {
        try {
            const stored = localStorage.getItem(this.storageKey);
            return stored ? JSON.parse(stored) : [];
        } catch {
            return [];
        }
    }

    clear() {
        localStorage.removeItem(this.storageKey);
    }
}

export default new Recents();
